import { CircularProgress, Modal, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 420,
    bgcolor: 'background.paper',
    border: '2px solid rgb(58 70 228)',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
    maxWidth: '70%',
};

export default function Loading(props: any) {
    const { isLoading } = useSelector((state: RootState) => state.shared);
    const isOpen = !!isLoading || !!props.loading;

    return (
        <div>
            <Modal open={isOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Stack sx={style} spacing={2} direction="column" alignItems="center">
                    <CircularProgress
                        color="primary"
                        size={48}
                        thickness={4}
                        sx={{
                            animationDuration: '700ms',
                        }}
                    />
                    <Typography id="modal-modal-title" variant="h6" component="h2" textAlign="center">
                        {props.message}
                    </Typography>
                </Stack>
            </Modal>
        </div>
    );
}
